import { API_BASE_URL } from '../config/api';
import Constants from "expo-constants";

export const loadSettings = async (keys = []) => {
  try{
    const response = await fetch(`${API_BASE_URL}/api/v1/setting`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
      },
      body: JSON.stringify({
        "keys": keys,
      }),
    });

    const result = await response.json();
    return result;

  } catch(e) {
    return [];
  }
}